declare global {
	type Result<TValue = unknown, TError = unknown> = { ok: true, value: TValue } | { ok: false, error: TError };
}

export function ok(): { ok: true, value: void };
export function ok<TValue>(value: TValue): { ok: true, value: TValue };
export function ok<TValue>(value?: any): { ok: true, value: TValue } {
	return { ok: true, value };
}

export function error(): { ok: false, error: void };
export function error<TError>(error: TError): { ok: false, error: TError };
export function error<TError>(error?: any): { ok: false, error: TError } {
	return { ok: false, error };
}

// Esta implementación de result valida que sólo estas asignaciones son correctas
// let r: Result = Math.random() > .5 ? ok() : error();
// let r1: Result<number> = Math.random() > .5 ? ok(4) : error();
// let r2: Result<number, Error> = Math.random() > .5 ? ok(4) : error(new Error());
